/*
  Keeps the price on the add-to-cart button in step with the quantity field and
  the chosen purchase option.

  Rendered server-side at quantity 1 on the one-time price, so with JS off the
  button still states a true price for the default selection rather than
  nothing at all.

  The subscription unit price is read off the selected radio, which Liquid
  stamped from the selling plan allocation. The theme never computes a discount
  of its own: the moment the percentage lives here rather than in the app, an
  edit in the subscription app turns the button into a false price.
*/
class CurbiLineTotal extends HTMLElement {
  connectedCallback() {
    const form = this.closest('form');
    this.input = form && form.querySelector('[name="quantity"]');
    if (!this.input) return;

    this.unit = Number(this.dataset.unit);
    this.template = this.textContent.trim().replace(/[\d.,]+/, '{{amount}}');
    this.input.addEventListener('change', () => this.render());

    form.querySelectorAll('[name="selling_plan"]').forEach((radio) => {
      radio.addEventListener('change', () => {
        const unit = Number(radio.dataset.unitPrice);
        // Fall back to the rendered one-time price rather than to NaN: a blank
        // button is worse than a slightly stale one.
        this.unit = Number.isFinite(unit) && unit > 0 ? unit : Number(this.dataset.unit);
        this.render();
      });
    });

    this.render();
  }

  render() {
    const qty = Math.max(1, Number(this.input.value) || 1);
    const total = (this.unit * qty) / 100;
    this.textContent = this.template.replace(
      '{{amount}}',
      total.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    );
  }
}

customElements.define('curbi-line-total', CurbiLineTotal);

/*
  Swaps uploaded product photography into the flavour-coloured stage.

  Thumb 0 is the stage's own flat tile and has no pane of its own, so showing it
  is simply hiding every pane. That keeps the tile the resting state for a
  product whose photography has not been shot yet.
*/
class CurbiGallery extends HTMLElement {
  connectedCallback() {
    this.panes = this.querySelectorAll('[data-curbi-pane]');
    this.thumbs = this.querySelectorAll('[data-curbi-thumb]');
    if (!this.thumbs.length) return;

    this.addEventListener('click', (event) => {
      const thumb = event.target.closest('[data-curbi-thumb]');
      if (thumb) this.show(thumb.dataset.curbiThumb);
    });
  }

  show(index) {
    this.panes.forEach((pane) => {
      pane.hidden = pane.dataset.curbiPane !== index;
    });
    this.thumbs.forEach((thumb) => {
      const active = thumb.dataset.curbiThumb === index;
      thumb.classList.toggle('is-active', active);
      thumb.setAttribute('aria-pressed', String(active));
    });
  }
}

customElements.define('curbi-gallery', CurbiGallery);
